var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.825562,
    y: 1.2793,
    width: 57.311,
    height: 57.5405,
    rx: 7.5,
    fill: "#FF6B00",
    fillOpacity: 0.1,
    stroke: "#FF6B00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7922 11.0752C42.5585 10.8698 43.3632 10.8548 44.1365 11.0312C45.673 11.3817 47.7183 12.2195 48.296 14.3757L51.2317 25.3318C51.5799 26.6312 50.8088 27.9668 49.5094 28.3149C48.2101 28.6631 46.8745 27.892 46.5263 26.5926L44.6518 19.5969L34.3767 40.1471C33.7243 41.452 32.525 42.3008 31.0037 42.3836C29.7335 42.4527 28.4902 41.9723 27.426 41.3999C26.3324 40.8118 25.5048 39.8282 25.112 38.6503L22.0166 29.364C21.8513 29.4044 21.6486 29.4654 21.4053 29.5547L12.2615 47.8422C11.66 49.0454 10.1969 49.5331 8.99373 48.9315C7.79056 48.3299 7.30288 46.8669 7.90446 45.6637L17.0481 27.3764C17.0481 27.3764 17.0482 27.3763 17.0482 27.3762C17.6035 26.2655 18.5621 25.4088 19.7278 24.9813C20.8623 24.5652 22.161 24.2653 23.4087 24.5134C24.903 24.8105 25.9702 25.8203 26.4316 27.2044L29.7333 37.1095L29.7334 37.1096C29.7334 37.1096 29.7334 37.1097 29.7334 37.1096C29.9616 37.2324 30.1536 37.3215 30.3115 37.3849L40.8136 16.3806L32.6345 18.5722C31.3352 18.9204 29.9996 18.1493 29.6514 16.8499C29.3033 15.5506 30.0744 14.215 31.3737 13.8668L41.792 11.0753C41.7921 11.0752 41.7922 11.0752 41.7922 11.0752ZM21.4053 29.5548C21.4053 29.5548 21.4053 29.5548 21.4053 29.5548L21.4053 29.5547C21.4054 29.5546 21.4054 29.5546 21.4053 29.5547L21.4053 29.5548ZM21.8102 28.7449L21.8104 28.7454C21.8103 28.7452 21.8103 28.7451 21.8102 28.7449ZM21.4052 29.5547C21.4052 29.5547 21.4052 29.5548 21.4053 29.5548L21.4052 29.5547Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnical);
export default __webpack_public_path__ + "static/media/technical.f0eb79539791174cb5e0fbd562c2efae.svg";
export { ForwardRef as ReactComponent };